import styled from "@emotion/styled";
import { MDSPanelWidths } from "@/mds/foundations";

export const Wrapper = styled.div<{
  $bottomBorderColor?: string;
}>`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: minmax(auto, max-content) minmax(auto, max-content) minmax(
      min-content,
      auto
    );
  grid-template-areas: "heading subsection actions";
  grid-column-gap: ${({ theme }) => theme.spacing["2"]};
  flex-shrink: 0;

  background-color: ${({ theme }) => theme.colors.surface.paneHeader};

  align-items: start;
  padding: ${({ theme }) => `${theme.spacing["4"]} ${theme.spacing["4"]} 0 ${theme.spacing["4"]}`};
  min-height: ${({ theme }) => theme.spacing["10"]};
  width: 100%;

  border-bottom: 1px solid transparent;

  @container mds-panel (max-width: ${MDSPanelWidths.headerBreakpoint}px) {
    grid-template-rows: minmax(auto, max-content) minmax(min-content, auto);
    grid-template-columns: auto auto;
    grid-template-areas:
      "heading actions"
      "subsection subsection";
  }
`;

export const HeadingArea = styled.div`
  grid-area: heading;
  overflow: hidden;
  align-items: center;
`;

export const SubsectionArea = styled.div`
  grid-area: subsection;
  overflow: hidden;
`;

export const ActionsArea = styled.div`
  grid-area: actions;
  justify-self: end;
`;

export const StyledHeading = styled.div<{ $hasSubsection: boolean }>`
  padding-inline: ${({ theme }) => theme.spacing["3"]};
  padding-bottom: ${({ theme }) => theme.spacing["3"]};

  @container mds-panel (max-width: ${MDSPanelWidths.headerBreakpoint}px) {
    padding-bottom: ${({ $hasSubsection, theme }) => ($hasSubsection ? "0px" : theme.spacing["3"])};
  }
`;
